<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.comment.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.comment.list.title"></app-i18n>
      </h1>

      <app-comment-list-toolbar></app-comment-list-toolbar>
      <app-comment-list-filter></app-comment-list-filter>
      <app-comment-list-table></app-comment-list-table>
    </div>
  </div>
</template>

<script>
import CommentListFilter from '@modules/comment/components/comment-list-filter.vue';
import CommentListTable from '@modules/comment/components/comment-list-table.vue';
import CommentListToolbar from '@modules/comment/components/comment-list-toolbar.vue';

export default {
  name: 'app-comment-list-page',

  components: {
    [CommentListFilter.name]: CommentListFilter,
    [CommentListTable.name]: CommentListTable,
    [CommentListToolbar.name]: CommentListToolbar,
  },
};
</script>

<style>
</style>
